/*eslint-disable*/
import { useState, useEffect, useContext } from 'react';
import ListHeader from '../SectionHeader';
import TablePagination from '../TablePaginationComponent';
import useFetchData from '../../hooks/useFetchData';
import useSort from '../../hooks/useSort';
import Filter from '../Filter';
import { ReactComponent as SortIcon } from '../../assets/images/sort.svg';
import { useNavigate } from 'react-router-dom';
import SnackBar from 'components/SnackBar';
import translating from './translate.json';
import GlobalContext from '../../contexts';
import useCustomForm from 'hooks/useCustomForm';
import { random } from 'lodash';
import usePostData from 'hooks/usePostData';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

import './styles.scss';
import ExcelDownload from 'components/ExcelDownload';

const ClientCyclePage = () => {
  const navigate = useNavigate();
  const { res, postData } = usePostData();
  const [data, setData] = useState([]);
  const { productsList, organizationsList } = useContext(GlobalContext);
  const { data: steppersData } = useFetchData('product-status');
  const { data: clientsData } = useFetchData('client');
  const { showFilters } = useSort();
  const [currentSteppersData, setCurrentSteppersData] = useState();
  const [currentClientsData, setCurrentClientsData] = useState();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (clientsData?.length) {
      setCurrentClientsData(clientsData);
    }
  }, [clientsData]);

  const tableHeadersClients = [
    translating.clientId,
    translating.clientName,
    translating.ssn,
    translating.phone,
    translating.email,
    translating.dateRegister,
    translating.parentName,
    translating.productName,
    translating.productStatus
  ];

  const columnsClients = [
    {
      value: 'id',
      sort: true
      // label: translating.clientId
    },
    {
      values: ['first_name', 'last_name'],
      sort: true,
      isArray: true
      // label: translating.clientName
    },
    { value: 'ssn', sort: true },
    { value: 'mobile', bold: true, sort: true },
    { value: 'email', bold: true, sort: true },
    { value: 'createdAt', format: 'date', sort: true },
    { value: 'parentName', sort: true },
    { value: 'productName', sort: true },
    { value: 'stepperValue', sort: true }
  ];

  const [sortFields, setSortFields] = useState();

  const onFilter = (filteredData) => {
    setFilteredCustomers(filteredData);
  };

  const onResetFilters = () => {
    setData([]);
  };

  const parents = ['', 'בדיקת סקר', 'בדיקה גנטית', 'חבילות המשך', 'טרום סכרת'];

  useEffect(() => {
    if (res?.success) {
      let data = res.data || [];
      data.map((item) => {
        let p = productsList.find((p) => p.id === item.productId).parentId;
        if (p === 0) p = productsList.find((p) => p.id === item.productId).id;
        item.parentName = parents[p];
        item.productName = productsList.find(
          (p) => p.id === item.productId
        ).name;
        item.stepperValue = item.text;
      });
      setLoading(false);
      setData(data);
    }
  }, [res]);

  const handleServerFilter = (filters) => {
    setLoading(true);
    postData('client-product/dashboard/productsByStatus', filters);
  };

  const { watch, renderForm } = useCustomForm({
    fields: sortFields,
    data: data,
    handleFilter: onFilter,
    handleReset: onResetFilters,
    ssf: handleServerFilter,
    defaultValues: {
      clientId: 'all',
      fromDate: null,
      productId: 'all',
      statusId: 'all',
      toDate: null,
      orgIds: 'all',
      clientStatus: 'all'
    }
  });

  const watchFilters = watch();
  let currentProduct;
  const fields = [
    {
      type: 'multiselect',
      label: translating.product,
      name: 'productId',
      options: productsList,
      isId: true
    },
    {
      type: 'multiselect',
      label: translating.statusProduct,
      name: 'statusId',
      options: currentSteppersData,
      isId: true
    },
    {
      type: 'date',
      subType: 'fromDate',
      label: translating.fromDate,
      name: 'fromDate',
      field: 'createdAt'
    },
    {
      type: 'date',
      subType: 'toDate',
      label: translating.toDate,
      name: 'toDate',
      field: 'createdAt'
    },
    {
      type: 'autocomplete',
      label: translating.client,
      name: 'clientId',
      options: currentClientsData,
      searchBy: 'full_name'
    },
    {
      type: 'multiselect',
      label: translating.organization,
      name: 'orgIds',
      options: organizationsList,
      isId: true
    },
    {
      type: 'select',
      label: 'סטטוס לקוח',
      name: 'clientStatus',
      options: [
        { id: 'true', name: 'פעיל' },
        { id: 'false', name: 'חסום' }
      ],
      isId: true
    }
  ];

  useEffect(() => {
    if (
      productsList?.length &&
      currentClientsData?.length &&
      organizationsList?.length
    ) {
      setSortFields([]);
      setTimeout(() => {
        setSortFields(fields);
      }, 0);
    }
  }, [
    steppersData?.length,
    productsList?.length,
    currentClientsData?.length,
    organizationsList?.length,
    currentSteppersData?.length
  ]);

  const getProductType = (cp) => {
    return cp.parentId === 0 ? cp.id : cp.parentId;
  };

  useEffect(() => {
    if (
      watchFilters.productId &&
      watchFilters.productId.length > 0 &&
      !watchFilters.productId.includes('all')
    ) {
      const selectedParentsIds = new Set();

      watchFilters.productId.forEach((productId) => {
        const productInfo = productsList.find(
          (p) => p.id.toString() === productId
        );
        if (productInfo) {
          const type = getProductType(productInfo);
          selectedParentsIds.add(type);
        }
      });

      // Filter steppers that match any of the selected product IDs
      const s = steppersData.filter((s) =>
        Array.from(selectedParentsIds).includes(s.productId)
      );

      // Map the steppers data to change text property to name
      const mappedSteppers = s.map((stepper) => ({
        ...stepper,
        name: stepper.text
      }));

      setCurrentSteppersData(mappedSteppers);
    } else {
      // If 'all' is selected or no products selected
      setCurrentSteppersData([]);
    }
  }, [watchFilters.productId, steppersData, productsList]);

  if (
    !Array.isArray(productsList) ||
    !productsList.length ||
    !Array.isArray(organizationsList) ||
    !organizationsList.length ||
    !Array.isArray(clientsData) ||
    !clientsData.length ||
    !Array.isArray(steppersData) ||
    !steppersData.length
  ) {
    return (
      <Box
        sx={{ display: 'flex', justifyContent: 'center', marginTop: '4rem' }}
      >
        <CircularProgress />
      </Box>
    );
  }
  return (
    <div className="report-list">
      <div className="wrapper-header">
        <ListHeader title={translating.reportTitle}></ListHeader>
        {data && data.length ? (
          <ExcelDownload
            data={data}
            filename={'clientProductStatusReport.csv'}
          ></ExcelDownload>
        ) : null}
      </div>

      {/* <Filter
        fields={sortFields}
        data={data}
        handleFilter={onFilter}
        handleReset={onResetFilters}
        ssf={handleServerFilter}
      ></Filter> */}
      {renderForm()}

      {loading ? (
        <Box sx={{ display: 'flex' }} className="loading">
          <CircularProgress />
        </Box>
      ) : (
        data && (
          <>
            <div className="count-clients">{`נמצאו ${data?.length} מוצרים `}</div>
            <div className="customers-list-wrapper-table">
              {productsList && productsList.length && (
                <TablePagination
                  headers={tableHeadersClients}
                  columns={columnsClients}
                  rows={data}
                  pagination={true}
                  useUId={true}
                  handleRowClick={(id) => {
                    navigate(`/clients/${id}`);
                  }}
                ></TablePagination>
              )}
            </div>
          </>
        )
      )}
    </div>
  );
};

export default ClientCyclePage;
